// countryflag component, props is: code, size, width, height

import React from "react";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";
import Image from "next/image";
import {getCountryName} from "@/base/utils/GetCountryName";

type CountryFlagProps = {
	code: string;
	width?: number;
	height?: number;
	className?: string;
	alt?: string;
}

const LocalCodes: Record<string, string> = {'ru': 'svg', 'zz': 'png', 'all': 'png'};
const getCountryFlagUrl = (code: string): string => {
	if (Object.keys(LocalCodes).find(c => c == code.toLowerCase().trim()))
	{
		const oCode = code.toLowerCase().trim();
		return `/base/image/${oCode}.${LocalCodes[oCode]}`;
	}

	return `/base/image/flag/${code.toLowerCase()}.svg`;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({code, width = 0, height = 25, className = '', alt = null}) => {
	// if 0 height is 16:9 ratio from wi
	if (width <= 0)
	{
		width = height * 1.5;
	}

	const router = useRouter();
	const {t} = useTranslation();

	const url = getCountryFlagUrl(code);
	const isSvg = url.endsWith('.svg');

	return (
		<Image
			src={getCountryFlagUrl(code)}
			alt={!alt ? `${t('base-common:flag')} ${getCountryName(code, router.locale || 'en')}` : alt}
			width={width}
			height={height}
			className={`object-cover rounded-md ${className || ''}`}
			// priority={false}
			loading={'lazy'}
		/>
	);
}